import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../Components/NavigationLayout";
import Edit from "./Edit";

const TeamFounderAdvisor = () => {
  return (
    <NavigationLayout>
      <Router history={history}>
        <Switch>
          <Route exact path="/admin/team-founder-advisor" component={List} />
          <Route path="/admin/team-founder-advisor/new" component={Add} />
          <Route path="/admin/team-founder-advisor/:id" component={Edit} />
        </Switch>
      </Router>
    </NavigationLayout>
  );
};
export default TeamFounderAdvisor;
